import { render, staticRenderFns } from "./InvoicesCDEKTableMobile.vue?vue&type=template&id=b7c56362&scoped=true"
import script from "./InvoicesCDEKTableMobile.vue?vue&type=script&lang=js"
export * from "./InvoicesCDEKTableMobile.vue?vue&type=script&lang=js"
import style0 from "./InvoicesCDEKTableMobile.vue?vue&type=style&index=0&id=b7c56362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c56362",
  null
  
)

export default component.exports